<template>
  <div :class="['colour-selector', { 'colour-selector--disabled': disabled }]">
    <div
      v-for="(colour, index) in fontColours"
      :key="index"
      :class="['colour-selector__item', { 'colour-selector__item--selected': colour === selectedColour }]"
      @click="emits('colourSelected', colour)"
    >
      <div class="colour-selector__item-inner-circle" :style="{backgroundColor: colour}" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { fontColours } from '@/static/colours'

const props = defineProps<{
  selectedColour: string | null,
  disabled: boolean
}>()

const emits = defineEmits<{
  (event: 'colourSelected', colourName: string): void
}>()

</script>
<style lang="scss">
.colour-selector {
  $root: #{&};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  &__item {
    border-radius: 50%;
    width: 22px;
    height: 22px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    &--selected {      
      // Creates the white circle border around the inner circle
      &::after {
        content:'';
        position: absolute;
        border-radius: 50%;
        border: 2px $white solid;
        width: 24px;
        height: 24px;
      }

      #{$root}__item-inner-circle {
        width: 12px;
        height: 12px;
      }
    }

    &-inner-circle {
      border-radius: inherit;
      width: inherit;
      height: inherit;
    }
  }

  &--disabled {
    pointer-events: none;
    #{$root}__item-inner-circle {
      opacity: 0.2;
    }
  }
}
</style>